import { render, staticRenderFns } from "./WorkflowPreviewIllustration.vue?vue&type=template&id=2fa3b15a&scoped=true"
import script from "./WorkflowPreviewIllustration.vue?vue&type=script&lang=js"
export * from "./WorkflowPreviewIllustration.vue?vue&type=script&lang=js"
import style0 from "./WorkflowPreviewIllustration.vue?vue&type=style&index=0&id=2fa3b15a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa3b15a",
  null
  
)

export default component.exports